import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from '@ane/core/lib/models';
export const defaultReducerState = {
    items: getDefaultAsyncWrapperObj(),
};
// Action Types
const actionTypesPrefix = 'loadDataSourceHistory';
export const dataSourceHistoryActionTypes = {
    LOAD: `${actionTypesPrefix}/LOAD`,
    LOADING: `${actionTypesPrefix}/LOADING`,
    LOADED: `${actionTypesPrefix}/LOADOADED`,
};
// Action Creators
export const dataSourceHistoryLoadAction = (workspaceId, dataSourceName) => {
    return {
        type: dataSourceHistoryActionTypes.LOAD,
        payload: { workspaceId: workspaceId, dataSourceName: dataSourceName },
    };
};
export const dataSourceHistoryLoadingAction = (payload) => {
    return {
        type: dataSourceHistoryActionTypes.LOADING,
        payload: payload,
    };
};
export const dataSourceHistoryLoadedAction = (payload, result) => {
    return {
        type: dataSourceHistoryActionTypes.LOADED,
        payload: {
            items: result,
        },
    };
};
// Reducer
export const reducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case dataSourceHistoryActionTypes.LOADING:
            return {
                ...state,
                items: {
                    ...state.items,
                    status: AsyncRequestStatus.Pending,
                },
            };
        case dataSourceHistoryActionTypes.LOADED:
            const loadedAction = action;
            return {
                ...state,
                items: loadedAction.payload.items,
            };
        default:
            return state;
    }
};
export default reducer;

//# sourceMappingURL=DataSourceDetailHistory.ducks.js.map
